export enum FORM_ACTIONS {
  SET_FIELD = 'SET_FIELD',
  RESET = 'RESET',
  SET_ERRORS = 'SET_ERRORS',
  SET_STOCK_WARNINGS = 'SET_STOCK_WARNINGS',
}
